// Panel depth options for KIKBLOX 2D.
// Total panel depth is always calculated as: component depth + busbar depth.
// Add new depth combinations here only - every screen uses this one list.

export interface DepthOption {
  component: number;   // component (equipment) chamber depth, mm
  busbar: number;      // busbar chamber depth, mm
  total: number;       // overall panel depth, mm
}

const depth = (component: number, busbar: number): DepthOption => ({
  component,
  busbar,
  total: component + busbar,
});

export const DEPTH_OPTIONS: ReadonlyArray<DepthOption> = [
  depth(200, 0),
  depth(200, 200),

  depth(300, 0),
  depth(300, 300),
  depth(300, 400),
  depth(300, 500),
  depth(300, 600),
  depth(300, 800),

  depth(400, 0),
  depth(400, 200),
  depth(400, 300),
  depth(400, 400),
  depth(400, 500),
  depth(400, 600),
  depth(400, 800),

  depth(500, 0),
  depth(500, 200),
  depth(500, 300),
  depth(500, 400),
  depth(500, 500),
  depth(500, 600),
  depth(500, 800),

  depth(600, 0),
  depth(600, 200),
  depth(600, 300),
  depth(600, 400),
  depth(600, 500),
  depth(600, 600),
  depth(600, 800),

  depth(700, 300),   // NEW: component 700 + busbar 300 = total 1000

  depth(800, 0),
  depth(1000, 0),
];

/** Fresh copy of the list, so a screen can never change the shared one. */
export function getDepthOptions(): DepthOption[] {
  return DEPTH_OPTIONS.map(o => ({ ...o }));
}

/** Overall panel depth = component + busbar (works for old saved projects too). */
export function getTotalDepth(option: { component?: any; busbar?: any; total?: any } | null | undefined): number {
  if (!option) { return 0; }
  const component = Number(option.component) || 0;
  const busbar = Number(option.busbar) || 0;
  return component + busbar || Number(option.total) || 0;
}

/** Text used in the drawing header, e.g. "Component : 700 | Busbar : 300 | Total Depth : 1000". */
export function depthLabel(option: { component?: any; busbar?: any; total?: any } | null | undefined): string {
  if (!option) { return ''; }
  return 'Component : ' + (option.component || 0) +
    ' | Busbar : ' + (option.busbar || 0) +
    ' | Total Depth : ' + getTotalDepth(option);
}